module.exports = "<p class=\"weui_cells_tips\"><slot></slot></p>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cells-tips.vue
 ** module id = 58
 ** module chunks = 0
 **/